import React from 'react';
import { Countdown } from '../Countdown';
export function Urgency() {
  return <section className="relative w-full overflow-hidden bg-[#350910] px-5 py-10 sm:py-12" data-id="element-247" data-mp="2flbqbjg6zx1y">
      <div className="relative mx-auto max-w-2xl text-center" data-id="element-248" data-mp="2bj706uoydik2">
        <p className="font-display text-xl uppercase tracking-wide text-white sm:text-3xl" data-id="element-249" data-mp="2bjqi4bels6y3">
          ⏳ Precio de lanzamiento — Cierra en:
        </p>

        <div className="mt-5" data-id="element-250" data-mp="33b66a9vt61qf"><Countdown data-id="element-251" data-mp="339cukg6c8rbk" /></div>
        <p className="mt-5 text-sm font-bold text-red-300 sm:text-base" data-id="element-252" data-mp="339v2wb69yvzu">⚠️ Después sube el precio. No vuelve.</p>

        <div className="mt-4" data-id="element-253" data-mp="2zbf5ddcki586">
          <div className="h-2 w-full overflow-hidden rounded-full bg-black/40" data-id="element-254" data-mp="2uhszq54tn1lv">
            <div className="h-full rounded-full bg-magenta" style={{
            width: '82%'
          }} data-id="element-255" data-mp="2pj9hoftcm9ys" />
          </div>
          <p className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-256" data-mp="3mydiq25e4x1v">
            82% de los cupos de lanzamiento ya reservados
          </p>
        </div>
      </div>
    </section>;
}